import type { ApiToggleFavoriteGamePort } from './ports/api-toggle-favorite-game.port';
import type { FavoriteGamesTogglePayload } from '~/types/favorite-game';

export class ToggleFavoriteGameHandler {
  // eslint-disable-next-line no-useless-constructor
  constructor(private apiToggleFavoriteGamePort: ApiToggleFavoriteGamePort) {}

  async handle(payload: FavoriteGamesTogglePayload) {
    return await this.apiToggleFavoriteGamePort.handle(payload);
  }
}
